module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.26.0@babel-runtime/core-js/object/define-property.js
// module id = 28
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.6.26.0@babel-runtime/core-js/object/define-property.js